import React from 'react';
import {SendProps} from 'react-native-gifted-chat';
import {IconButton, useTheme} from 'react-native-paper';
import {Keyboard} from 'react-native';
import {useAppDispatch, useAppSelector} from '../../../store/hooks';
import {setDraftMessage} from '../../../store/slices/chat';
import {ChatMessage} from '../../../types';

export function ChatSendButton({
  sendProps,
  chatId,
}: {
  sendProps: SendProps<ChatMessage>;
  chatId: string;
}) {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const draftMessage = useAppSelector(
    state => state.chat.draftMessage[chatId],
  );

  return (
    <IconButton
      {...sendProps}
      iconColor={theme.colors.onSurface}
      size={28}
      style={{right: 5, top: -15, position: 'absolute', zIndex: 10}}
      icon={'send'}
      // testID={TestIDs.CONVERSATION_SEND_BUTTON}
      onPress={() => {
        if (sendProps && sendProps.onSend)
          sendProps?.onSend({text: draftMessage}, true);
        dispatch(setDraftMessage({id: chatId, content: undefined}));
        Keyboard.dismiss();
      }}
    />
  );
}
